import type { AppRedirect } from '#src/shared/routes';

export const REDIRECTS: readonly AppRedirect[] = [
	{
		path: '/decision-makers/:slug/admin',
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		buildUrl: ({ params: { slug }, queryString }) => `/admin/decision-makers/${slug!}${queryString}`,
		reason: 'moved',
		permanent: true,
	},
];
